const inView = require( 'in-view' );




module.exports = {
    init: function()
    {
        // not on mobile 
        if(window.matchMedia("(min-width: 1024px)").matches) {
            inView.offset(50);

            let animatedElementsSelector = '.animate';
            let animatedElements = Array.from(document.querySelectorAll(animatedElementsSelector));

            animatedElements.forEach( el => {
                
                el.classList.add("will-animate");
            })

            

            inView(animatedElementsSelector)
                .on('enter', el => {

                    if(!el.shown) {
                        el.shown = true;
                        el.classList.add("will-animate--visible");
                    }
                });
        }

    }
}
